export default {
  title: 'Instrumente zur Unterstützung der Entscheidungsfindung',
  description: 'Estimator24 hilft Käufern, Investoren und Agenturen, fundierte Entscheidungen auf Basis von Daten und KI zu treffen.',
  features: {
    evaluation: 'Immobilienbewertung mit einem Klick',
    forecast: 'Preisprognosen mit Hilfe von neuronalen Netzen',
    analytics: 'Marktanalyse nach Regionen und Stadtteilen',
    tools: 'Werkzeuge zum Vergleichen und Filtern'
  }
}
